import {
  XYChartAxisInternal,
  type XYChartOrientation,
} from '../../../types/xy-chart-internals.js';
import {
  BAR_VARIANT_GROUP,
  type BarSeriesVariant,
} from '../../../types/xy-chart.js';

export const isGrouping = (
  variant: BarSeriesVariant,
  chartOrientation: XYChartOrientation | undefined,
  xAxis: XYChartAxisInternal,
  yAxis: XYChartAxisInternal,
) => {
  if (
    variant !== BAR_VARIANT_GROUP ||
    !chartOrientation ||
    chartOrientation === 'both'
  ) {
    return false;
  }

  const primaryAxis = chartOrientation === 'vertical' ? xAxis : yAxis;
  return primaryAxis.type === 'categorical';
};
